import React, { useCallback, useState, useEffect } from "react";
import { getDate, fetchGet, fetchDelete } from "../../utils";
import { Title } from "..";

export default function Sms() {
  const [messages, setMessages] = useState("");
  const [messagesElements, setMessagesElements] = useState(null);

  const makeMessageHtml = useCallback(
    ({ _id: messageId, date, content, images }) => {
      const dateString = getDate(date);
      let links = "";
      if (images) {
        const linkArray = images.map((image) => (
          <p key={image}>
            <a href={image} rel="noreferrer" target="_blank">
              <img src={image} alt="text attachment" />
            </a>
          </p>
        ));
        links = linkArray;
      }
      const messageHtml = (
        <div key={content + dateString}>
          <p className="message-header">
            <strong>{dateString}</strong>
            <button
              onClick={() => confirmDelete(messageId)}
              className="link-button link-button--delete"
              id="delete-btn"
            >
              Delete Message
            </button>
          </p>
          <pre>
            <code>{content}</code>
          </pre>
          {links || ""}
          <hr />
        </div>
      );
      return messageHtml;
    },
    []
  );

  useEffect(() => {
    (async () => {
      const { body } = await fetchGet({
        url: "/api/sms",
        onError: console.error,
      });
      if (body) {
        setMessages(body.messages);
      }
    })();
  }, []);

  useEffect(() => {
    if (!messages) {
      setMessagesElements(<strong>Loading...</strong>);
    } else if (messages.length === 0) {
      setMessagesElements(<strong>No messages found</strong>);
    } else {
      setMessagesElements(messages.map(makeMessageHtml));
    }
  }, [messages, makeMessageHtml]);

  const confirmDelete = async (messageId) => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      const { body } = await fetchDelete({
        data: { messageId },
        onError: console.error,
        url: "/api/sms",
      });
      if (body) {
        setMessages(body.messages);
      }
    }
  };

  return (
    <>
      <Title title="SMS Messages" />

      <h1>Messages</h1>
      {messagesElements}
    </>
  );
}
